export default __webpack_public_path__ + "static/media/f3.a32ab829.svg";